import { createContext, useContext, useEffect, useState } from "react";
import { content } from "./content";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("iph_lang") || "en");
  useEffect(() => {
    localStorage.setItem("iph_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.classList.toggle("lang-hi", lang === "hi");
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: content[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
